import apiService from "@/lib/api";

const BRANDING_BASE = "/api/v2/branding";

const unwrap = (response) => response?.data?.data ?? response?.data ?? response;

export const BrandingService = {
  getCurrent: async () => {
    const response = await apiService.getSecure(`${BRANDING_BASE}/current`);
    return unwrap(response);
  },

  saveDraft: async (payload) => {
    const response = await apiService.putSecure(`${BRANDING_BASE}/draft`, payload);
    return unwrap(response);
  },

  publishDraft: async () => {
    const response = await apiService.postSecure(`${BRANDING_BASE}/draft/publish`);
    return unwrap(response);
  },

  discardDraft: async () => {
    const response = await apiService.postSecure(`${BRANDING_BASE}/draft/discard`);
    return unwrap(response);
  },

  // Reverts the saved draft's display name to published — draft assets are
  // left alone. The narrower counterpart to discardDraft, which deletes the
  // whole draft row (assets included).
  discardDraftConfig: async () => {
    const response = await apiService.postSecure(`${BRANDING_BASE}/draft/discard-config`);
    return unwrap(response);
  },

  uploadAsset: async ({ assetKind, file }) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiService.postSecure(
      `${BRANDING_BASE}/assets/upload?assetKind=${assetKind}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return unwrap(response);
  },

  deleteAsset: async ({ assetKind, scope = "draft" }) => {
    const response = await apiService.delete(
      `${BRANDING_BASE}/assets/${assetKind}?scope=${scope}`
    );
    return unwrap(response);
  },

  // Paginated — omitting page/perPage lets the server apply its own
  // defaults (page 1, 10 per page). Returns {items, pagination} rather than
  // going through `unwrap`, which would drop the pagination envelope.
  getHistory: async ({ page, perPage } = {}) => {
    const params = new URLSearchParams();
    if (page) params.set("page", page);
    if (perPage) params.set("per_page", perPage);
    const qs = params.toString();
    const response = await apiService.getSecure(`${BRANDING_BASE}/history${qs ? `?${qs}` : ""}`);
    const body = response?.data ?? {};
    return { items: body.data ?? [], pagination: body.pagination ?? null };
  },

  rollbackToHistory: async (historyId) => {
    const response = await apiService.postSecure(
      `${BRANDING_BASE}/rollback/${historyId}`
    );
    return unwrap(response);
  },
};

export default BrandingService;